/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/currencyFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoCurrencyField implements angular.IDirective {
        restrict = "E";
        require = 'ngModel';
        scope = {
            currentValue: "=ngModel",
            contentKey: "@",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            decimalMask: "=?",
            maxValue: "=?",
            minValue: "=?",
            onEnter: "&?",
            ngChange: "&?",
            ngBlur: "&?",
            nullPlaceholder: "@",
            supportsNull: "=",
            backgroundColor: "=",
            zeroInvalid: "=?",
            name: "@",
            tabIndex: "=?",
            reselect: "&?",
            allowNegatives: "=?",
            allowZero: "=?",
            currencyPosition: "@?",
            autoChangeMin: "@?",
            autoChangeMax: "@?",
            zeroUnlimited: "@?",
            inputInvalid: "=?",
            invalidMinValueMessage: "@?",
        };

        templateUrl = "app/components/controls/currencyFieldTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            scope.inputWasOverMax = false;
            scope.inputWasUnderMin = false;

            // certain underlying procs allow zero to signify no upper or lower limit, allow to override UI rules to accomodate
            var autoChangeMin = scope.autoChangeMin !== 'false';
            var autoChangeMax = scope.autoChangeMax !== 'false';
            var zeroUnlimited = scope.zeroUnlimited === 'true';

            var input: any = element.find('input');
            var oldCurrentVal;
            if (scope.nullPlaceholder)
                input.attr("placeholder", this.$translate.instant(scope.nullPlaceholder));
            let filter: any = this.$filter;
            let meevoCurrency = filter('meevoCurrency');
            let timeout = this.$timeout;
            let document = this.$document;
            let locale = this.$locale;
            if (angular.isUndefined(scope.reselect)) {
                scope.reselect = false;
            }
            if (angular.isUndefined(scope.decimalMask)) {
                let identity = this.identityService.current();
                scope.decimalMask = identity.decimalPositions || 2;
            }

            if (angular.isUndefined(scope.allowZero)) {
                scope.allowZero = true;
            }

            if (angular.isUndefined(scope.allowNegatives)) {
                scope.allowNegatives = false;
            }

            const maxCurrency = 999999999.99;

            if (angular.isUndefined(scope.maxValue)) {
                scope.maxValue = maxCurrency;
            }
            if (angular.isUndefined(scope.minValue)) {
                scope.minValue = scope.allowNegatives ? -maxCurrency : 0;
            }

            scope.isInputInvalid = function() {
                return (scope.required && ((scope.currentValue <= 0 && scope.zeroInvalid) || scope.currentValue == null)) || scope.inputWasUnderMin || scope.inputWasOverMax || scope.inputInvalid;
            }

            scope.onBlur = function () {
                if (zeroUnlimited && (+scope.minValue === 0 || +scope.currentValue === 0)) return;
                // Case where currentValue is undefined so just set it to null if that's supported so it can be handled properly below
                if (angular.isUndefined(scope.currentValue) && scope.supportsNull)
                {
                    scope.currentValue = null;
                }
                // If null and null support just abort b/c otherwise null will be converted to 0 below
                if (Model.Guard.isNothing(scope.currentValue) && scope.supportsNull) {
                    return;
                }
                scope.currentValue = +scope.currentValue;

                if (isNaN(scope.currentValue) && !scope.supportsNull) {
                    scope.currentValue = '0';
                }

                if (+scope.currentValue < +scope.minValue && (autoChangeMax || (!autoChangeMax && scope.currentValue > 0))) {
                    scope.inputWasUnderMin = true;
                    scope.currentValue = scope.minValue;
                    setTimeout(() => {
                        scope.inputWasUnderMin = false;
                        scope.$apply();
                    }, 2000);
                }

                if (!scope.allowZero && scope.currentValue == 0) {
                    let defaultZeroValue = ".";
                    for (let i = 0; i < scope.decimalMask - 1; i++) {
                        defaultZeroValue += "0";
                    }
                    defaultZeroValue += "1";
                    scope.currentValue = defaultZeroValue;
                }
            }

            scope.valueChanged = function () {
                if (!(zeroUnlimited && +scope.maxValue === 0)) {
                    if (+scope.currentValue > +scope.maxValue && (autoChangeMin || (!autoChangeMin && scope.maxValue > 0))) {
                        scope.inputWasOverMax = true;
                        scope.currentValue = scope.maxValue;
                        setTimeout(() => {
                            scope.inputWasOverMax = false;
                            scope.$apply();
                        }, 2000);
                    }
                };


                if (_.isFunction(scope.ngChange)) {
                    timeout(() => {
                        scope.ngChange();
                    });
                }
            }

            scope.handleNullValue = () => {
                if (Model.Guard.isNothing(scope.currentValue, false)) {
                    if (scope.supportsNull) {
                        scope.currentValue = null;
                    } else {
                        scope.currentValue = 0;
                    }
                }
            }

            scope.handleNullValue();

            scope.formatCurrValue = () => {
                if (scope.currentValue === null && scope.supportsNull) {
                    return;
                }

                if (Model.Guard.isSomething(scope.currentValue) || !scope.currentValue) {
                    input.val(meevoCurrency(scope.currentValue, null, locale.NUMBER_FORMATS.CURRENCY_SYM, scope.decimalMask, scope.currencyPosition));
                }
            };

            window.setTimeout(scope.formatCurrValue, 40)

            var deregWatchCurrValue = null;
            scope.initializeWatchCurrValue = () => {
                if (deregWatchCurrValue == null) {
                    deregWatchCurrValue = scope.$watch("currentValue", function (newVal, oldVal, currScope) {
                        oldCurrentVal = newVal;
                        scope.formatCurrValue();
                    });
                }
            };
            scope.initializeWatchCurrValue();
            input.focus(function (event: BaseJQueryEventObject) {
                scope.$emit("focus");
                window.setTimeout(function () {
                    $(input[0]).val(scope.currentValue);
                    var selectionEnd = input[0].selectionEnd;
                    input[0].setSelectionRange(0, selectionEnd);
                }, 100);
            })

            input.bind("focus", function () {
                if (deregWatchCurrValue != null) {
                    deregWatchCurrValue();
                    deregWatchCurrValue = null;
                }
                input.val(scope.currentValue);
                input.select();
                if (_.isFunction(scope.onEnter)) {
                    scope.onEnter();
                }
            });

            if (scope.reselect) {
                input.click(function () {
                    window.setTimeout(function () {
                        input[0].setSelectionRange(0, input[0].value.length);
                    }, 100)
                });
            }

            input.bind("blur", function () {
                scope.handleNullValue();
                scope.formatCurrValue();
                scope.initializeWatchCurrValue();
                if (_.isFunction(scope.ngBlur)) {
                    timeout(() => {
                        scope.ngBlur();
                    });

                }
            });

            input.on("keydown", (event: JQueryEventObject) => {
                let decimalPointKeyCodes = [110, 190]; //   188=','(comma) 110='.'(decimal point) 190='.'(period)
                let negativeSignKeyCodes = [109, 189];
                let target = <HTMLInputElement>event.target;
                let currentValue = String(scope.currentValue || '');
                let keyCode = event.keyCode || event.which; // Cross-Browser Support
                let isAllSelected = target.selectionStart == 0 && target.selectionEnd == currentValue.length;

                if (isAllSelected && _.contains(decimalPointKeyCodes, keyCode) && !event.shiftKey) {
                    scope.currentValue = "0";
                    scope.$apply();
                } else if ((currentValue.length === 0 || isAllSelected) && scope.allowNegatives && _.contains(negativeSignKeyCodes, keyCode)) {
                    scope.currentValue = "-";
                    scope.$apply();
                }

                if (_.contains([46, 8, 9, 27, 13], keyCode) ||
                    // Allow: Ctrl+A
                    (keyCode === 65 && event.ctrlKey) ||
                    // Allow: Ctrl+C
                    (keyCode === 67 && event.ctrlKey) ||
                    // Allow: Ctrl+X
                    (keyCode === 88 && event.ctrlKey) ||
                    // Allow: home, end, left, right
                    (keyCode >= 35 && keyCode <= 39)) {
                    if (keyCode === 13 && _.isFunction(scope.onEnter)) {
                        timeout(() => {
                            scope.onEnter({ event: event });
                        });
                    }
                    return;
                }
                let isAltKeyAndNumber = (event.altKey && keyCode > 47 && keyCode < 58) || (event.altKey && keyCode > 95 && keyCode < 106)
                let isCurrentValueNegative = +(scope.currentValue) < 0 || scope.currentValue[0] === '-' || scope.currentValue.length > 0;
                let isCurrentValueDecimal = scope.currentValue.toString().indexOf('.') > -1;

                if (isAltKeyAndNumber) {
                    event.preventDefault();
                } else if (scope.allowNegatives && !isCurrentValueNegative && _.contains(negativeSignKeyCodes, keyCode)) {
                    return;
                } else if (!isCurrentValueDecimal && _.contains(decimalPointKeyCodes, keyCode)) {
                    return;
                }
                else if (event.key !== undefined && !('1234567890').includes(event.key)) {
                    //modern browsers
                    event.preventDefault();
                }
                else if (event.key === undefined && isValidNumInput(keyCode)) {
                    // old browsers
                    event.preventDefault();
                }


                // Validate decimals
                let caret = target.selectionStart;
                if (caret != undefined) {
                    let newValue: string = '';
                    let decimals: string = '';

                    if (event.key !== undefined) {
                        // modern browsers
                        newValue = currentValue.slice(0, caret) + event.key + currentValue.slice(caret, currentValue.length);
                        decimals = newValue.split(locale.NUMBER_FORMATS.DECIMAL_SEP)[1];
                    }
                    else if (event.keyCode !== undefined) {
                        // older browsers
                        newValue = currentValue.slice(0, caret) + String.fromCharCode(keyCode) + currentValue.slice(caret, currentValue.length);
                        decimals = newValue.split(locale.NUMBER_FORMATS.DECIMAL_SEP)[1];
                    }

                    if (Model.Guard.isSomething(decimals) && decimals.length > scope.decimalMask) {
                        event.preventDefault();
                    }
                }
                return true;
            });

            function isValidNumInput(aKeyCode): boolean {

                // if keycode is input from numPad, convert to digit keyCode
                if (aKeyCode >= 96 && aKeyCode <= 105) {
                    aKeyCode = aKeyCode - 48;
                }
                // if charCode has a corresponding number, its set to 0-9 else digit = NaN
                let digit: number = +String.fromCharCode(aKeyCode);

                return _.isNaN(digit);

            }

            scope.$watch("currentValue", function (newValue, oldValue) {
                if (scope.allowNegatives && scope.currentValue == "-") {
                    return;
                }
                // We check what value we get. It returns the previous value if we insert a non-numeric value into the field
                if (isNaN(Number(scope.currentValue))) {
                    scope.currentValue = oldValue;
                }
                validate();
            }, true);

            function validate() {
                if (scope.zeroInvalid && !scope.allowNegatives) {
                    scope.isInvalid = scope.currentValue <= 0;
                    ngModel.$setValidity("zero", !scope.isInvalid);
                }
            }
        }

        constructor(
            private $filter: ng.IFilterService,
            private $translate: angular.translate.ITranslateService,
            private $timeout,
            private identityService: Meevo.Components.Common.IIdentityService,
            private $document,
            private $locale: angular.ILocaleService
        ) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($filter: ng.IFilterService, $translate: angular.translate.ITranslateService, $timeout, identityService: Meevo.Components.Common.IIdentityService, $document, $locale: angular.ILocaleService) => {
                return new MeevoCurrencyField($filter, $translate, $timeout, identityService, $document, $locale);
            };
            directive.$inject = ["$filter", "$translate", "$timeout", "meevo.components.common.IdentityService", "$document", "$locale"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoCurrencyField", MeevoCurrencyField.factory());
}
